import { OVER_RED, OVER_YELLOW, ON, UNDER } from './budget-status'
import { BEHIND_RED, BEHIND_YELLOW, AHEAD } from './schedule-status'

/**
 * For the given BudgetStatus or ScheduleStatus, returns an appropriate icon
 * and color to represent the status. Does not take into account things like
 * forceRedScheduleStatus(), so this should only be used internally to this
 * module.
 *
 * @param {BudgetStatus|ScheduleStatus} status
 *
 * @return {{statusColor: string, statusIcon: string}}
 */
function getStatusIconAndColor (status) {
	switch (status) {
		case UNDER:
		case AHEAD:
		case ON:
			return {
				statusIcon: 'approved',
				statusColor: 'green'
			}
		case OVER_YELLOW:
		case BEHIND_YELLOW:
			return {
				statusIcon: 'exclamation',
				statusColor: 'yellow'
			}
		case OVER_RED:
		case BEHIND_RED:
			return RED_ICON_AND_COLOR
		default:
			return {
				statusIcon: 'question-mark',
				statusColor: 'gray'
			}
	}
}

const RED_ICON_AND_COLOR = {
	statusIcon: 'cross',
	statusColor: 'red'
}

const YELLOW_ICON_AND_COLOR = {
	statusIcon: 'exclamation',
	statusColor: 'yellow'
}

/**
 * For the given initiative, returns an appropriate icon and color to represent
 * the schedule status. Note that the color intentionally does not have a
 * lightness suffix (eg 'red' instead of 'red-medium'), because it's used for a
 * CSS class.
 *
 * @param {Initiative} model
 * @return {{statusColor: string, statusIcon: string}}
 */
function getScheduleStatusIconAndColor (model) {
	let pastDueDateStatus = model.getPastDueDateStatus()
	if (pastDueDateStatus === BEHIND_RED) {
		return RED_ICON_AND_COLOR
	} else if (pastDueDateStatus === BEHIND_YELLOW) {
		return YELLOW_ICON_AND_COLOR
	}

	return getStatusIconAndColor(model.get('projectedSchedule')?.status)
}

/**
 * For the given initiative, returns an appropriate icon and color to represent
 * the budget status. Note that the color intentionally does not have a
 * lightness suffix (eg 'red' instead of 'red-medium'), because it's used for a
 * CSS class.
 *
 * @param {Initiative} model
 * @return {{statusColor: string, statusIcon: string}}
 */
function getBudgetStatusIconAndColor (model) {
	return getStatusIconAndColor(model.get('projectedBudget')?.status)
}

export { getScheduleStatusIconAndColor, getBudgetStatusIconAndColor }
